import { OrderListMassActionsEnum } from '../../../../actions/utils/orderListMassActions';
import { OrderListMassActionsAlertContentProps } from '../types/OrderListMassActionsAlertContent.types';
import ApproveOrdersMassActionAlertContent from './components/ApproveOrdersMassActionAlertContent';

const OrderListMassActionsAlertContent = ({
  action,
  onChangeUpdateConditionsOnStatusChange,
  updateConditionsOnStatusChange,
}: OrderListMassActionsAlertContentProps) => {
  switch (action.type) {
    case OrderListMassActionsEnum.APPROVE_ORDERS:
      return (
        <ApproveOrdersMassActionAlertContent
          updateConditionsOnStatusChange={updateConditionsOnStatusChange}
          onChangeUpdateConditionsOnStatusChange={onChangeUpdateConditionsOnStatusChange}
        />
      );
    default:
      return null;
  }
};

export default OrderListMassActionsAlertContent;
